export default __webpack_public_path__ + "static/Inter-italic.var-30807be7abc48ba8c73c5e971fc46438.woff2";